'use client'
import { Page } from '@/modules/pages/types';
import { SidebarItem } from './SidebarItem';
import { NewReportPlusIcon } from '@/components/icons/NewReportPlusIcon';
import { DefaultReportIcon } from '@/components/icons';
import { SidebarItemGroupProps } from './types';

export const SidebarItemGroup = ({
  title,
  icon,
  pages,
  currentPageId,
  onPageClick,
  onNewPageClick,
  sidebarCollapsed,
  badge,
  isLoading = false,
  isCreating = false,
  onGroupHeaderClick,
  isGroupHeaderActive = false,
  isPageDisabled,
  getPageLabel,
}: SidebarItemGroupProps) => {

  if (sidebarCollapsed) {
    return (
      <div className="w-full space-y-1">
        <SidebarItem
          icon={icon}
          label={title}
          isCollapsed={sidebarCollapsed}
          isActive={isGroupHeaderActive}
          onClick={onGroupHeaderClick}
        />
        <div className='flex flex-col w-full gap-y-2'>
          {pages.slice(0, 5).map((page) => (
            <SidebarItem
              key={page.id}
              icon={
                page.icon ? (
                  <img className='w-8 h-8' src={`${window.location.origin}/icons/product/${page.icon}.svg`} alt={getPageLabel?.(page) ?? page.title} />
                ) : (
                  <DefaultReportIcon className="w-8 h-8" />
                )
              }
              label={getPageLabel?.(page) ?? page.title}
              isActive={page.id === currentPageId}
              onClick={() => onPageClick(page)}
              isDisabled={isPageDisabled?.(page) ?? false}
              isCollapsed={sidebarCollapsed}
              customActiveStyle={false}
            />
          ))}
          <SidebarItem
            icon={
              <div className='w-8 h-8'>
                <NewReportPlusIcon />
              </div>
            }
            label={"New Page"}
            onClick={isCreating ? undefined : onNewPageClick}
            isClickable={!isCreating}
            isCollapsed={sidebarCollapsed}
          />
        </div>
      </div>
    );
  }

  return (
    <div className="w-full">
      <SidebarItem
        icon={icon}
        label={title}
        badge={badge}
        isActive={isGroupHeaderActive}
        onClick={onGroupHeaderClick}
        isCollapsed={false}
        customActiveStyle={false}
      />

      <div className="space-y-1">
        <div className="max-h-[500px] overflow-y-auto scrollbar-thin space-y-1 mt-1 text-ellipsis">
          {pages.map((page, index) => (
            <SidebarItem
              key={`${page.id}-${index}`}
              icon={
                <div className='pl-10'>
                  {page.icon ? (
                    <img className='w-8 h-8' src={`${window.location.origin}/icons/product/${page.icon}.svg`} alt={getPageLabel?.(page) ?? page.title} />
                  ) : (
                    <DefaultReportIcon className="w-8 h-8" />
                  )}
                </div>
              }
              label={getPageLabel?.(page) ?? page.title}
              isActive={page.id === currentPageId}
              onClick={() => onPageClick(page)}
              isDisabled={isPageDisabled?.(page) ?? false}
              isCollapsed={false}
              customActiveStyle={false}
            />
          ))}
        </div>

        {!isLoading && (
          <SidebarItem
            icon={
              <div className='pl-10 flex items-center'>
                <div className='w-[32px] h-[32px]'>
                  {isCreating ? (
                    <div className="animate-spin rounded-full h-5 w-5 border-2 border-white/20 border-t-white"></div>
                  ) : (
                    <NewReportPlusIcon />
                  )}
                </div>
              </div>
            }
            label={isCreating ? "Creating..." : "New Page"}
            onClick={isCreating ? undefined : onNewPageClick}
            isClickable={!isCreating}
            isCollapsed={false}
          />
        )}
      </div>
    </div>
  );
};
